import Layout from "../../../components/layout/layout.js";

import ScoutingOverviewForm from "../../../components/form/scouting-overview.form";

function ScoutingOverviewPage({ component, ...rest }) {
  return <Layout Component={ScoutingOverviewForm} {...rest} controlsDisabled={true}   />;
}

export default ScoutingOverviewPage;
